import { apiClient } from '@/services/api'
import type { ExperienceLabAccess } from './experienceLabAccess.types'

export const experienceLabAccessService = {
  async getAccess(): Promise<ExperienceLabAccess> {
    const { data } = await apiClient.get<ExperienceLabAccess>(
      '/experience_lab/access'
    )

    return data
  },
}
